/* eslint-disable @typescript-eslint/naming-convention */
import isEmpty from 'lodash/isEmpty';

import pushClevertapEvent from '../pushClevertapEvent';
import formatPhoneNumber from '../formatPhoneNumber';

export function settingPublicProfileStart(data) {
  pushClevertapEvent('Setting Public Profile Start', data);
}

export function settingPublicProfileSaveSuccess(business) {
  const mapping = {
    name: 'Business Name',
    description: 'Business Description',
    address: 'Business Address',
    province: 'Province',
    city: 'City',
    postal_code: 'Postal Code',
    email: 'Email',
    website: 'Web',
    twitter: 'Twitter',
    facebook: 'Facebook',
    instagram: 'Instagram',
  };

  const sentPayload = Object.entries(mapping).reduce((memo, [key, value]) => {
    if (!isEmpty(business[key])) memo[value] = business[key];
    return memo;
  }, {});

  if (!isEmpty(business.phone))
    sentPayload['Phone Number'] = formatPhoneNumber(business.phone);

  pushClevertapEvent('Setting Public Profile Save Successful', sentPayload);
}
